import StackOverflowComponent from 'components/marketingSite/stackOverflow/StackOverflowComponent';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { config } from 'utils/config';

const StackOverflowLandingPage: React.FC = () => {
  const { t } = useI18n('stackOverflowLanding');

  usePageTrack('Landing - Page Loaded');

  const [origin, setOrigin] = useState('');

  useEffect(() => {
    setOrigin(window.location.origin);
  }, []);

  return (
    <>
      <Head>
        <title>{t('page_title')}</title>

        <meta property="og:title" content={t('og.title') || ''} />
        <meta
          property="og:image"
          content={'https://www.getmanfred.com/images/stackoverflowgeddon.png'}
        />
        <meta property="og:url" content={`${origin}/stackoverflowgeddon`} />
        <meta property="og:description" content={t('og.description') || ''} />
        <meta name="twitter:card" content="summary_large_image"></meta>
      </Head>
      <StackOverflowComponent />
    </>
  );
};

export default StackOverflowLandingPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'stackOverflowLanding'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
